import React from 'react';
import MaterialFilter from '../MaterialFilter.js';

export default function Main() {
  return (
    <div>
      <MaterialFilter />
    </div>
  );
}
